<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="70px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="标题：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.title" placeholder="请输入标题"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="转出人员：" prop="fromUserId" class="mr0">
            <el-select size="mini" v-model="form.fromUserId" filterable placeholder="请选择接收人员" clearable reserve-keyword
              :remote="true" :remote-method="getUserSimpleListFun" @change="handleSearchListData"
              @visible-change="getUserSimpleListFun('')" value-key="userId">
              <el-option v-for="item in peopleList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收人员：" prop="toUserId" class="mr0">
            <el-select size="mini" v-model="form.toUserId" filterable placeholder="请选择接收人员" clearable reserve-keyword
              :remote="true" :remote-method="getUserSimpleListFun" @change="handleSearchListData"
              @visible-change="getUserSimpleListFun('')" value-key="userId">
              <el-option v-for="item in peopleList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售项目：" prop="projectId">
            <el-select size="mini" v-model="form.projectId" filterable placeholder="请选择销售项目" clearable reserve-keyword
              :remote="true" :remote-method="searchProjectList" @change="handleSearchListData"
              @visible-change="searchProjectList('')">
              <el-option v-for="item in projectList" :key="item.id" :label="item.projectName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button v-if="hasRole['YJDTJ']" size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" v-if="hasRole['YJDSC']" plain>删除
        </el-button>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="title" label="标题"></el-table-column>
          <el-table-column show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="planNo" label="关联计划"></el-table-column>
          <el-table-column show-overflow-tooltip prop="fromUserName" label="转出人"></el-table-column>
          <el-table-column show-overflow-tooltip prop="toUserName" label="接收人"></el-table-column>
          <el-table-column show-overflow-tooltip prop="statusName" label="状态"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="添加时间"></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" v-if="hasRole['YJDBJ']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" v-if="hasRole['YJDSC']"></div>
              <el-button size="mini" type="text" v-if="hasRole['YJDSC']" @click="handleDeleteCause(scope.row)">删除
              </el-button>
              <div class="btn-divide" v-if="hasRole['YJDJS'] && scope.row.acceptStatus!= null"></div>
              <el-button size="mini" type="text" v-if="hasRole['YJDJS'] && scope.row.acceptStatus!= null"
                @click="handleAcceptCause(scope.row)">
                接收
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <add-cause v-if="addCauseVisible" @cancel="addCauseVisible = false" @confirm="handleAddCauseConfirm"></add-cause>
    <edit-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
      @confirm="handleEditCauseConfirm"></edit-cause>
  </div>
</template>

<script>
  import {
    getPageList,
    deleteData,
    accept,
    getUserSimpleList
  } from "@/api/salesManagement/transferOrder";
  import {
    getProjectSimpleList
  } from "@/api/salesManagement/ProjectManagement";
  import AddCause from "./components/AddCause";
  import EditCause from "./components/EditCause";
  export default {
    name: "SalesManagementBFJL",
    components: {
      AddCause,
      EditCause,
    },
    data() {
      return {
        form: {
          projectId: null,
          fromUserId: null,
          toUserId: null,
          title: ''
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addCauseVisible: false,
        editCauseVisible: false,
        checkDepartment: false,
        causeDetail: {},
        createTime: null,
        canSearch: false,
        peopleList: [],
        projectList: []
      };
    },
    computed: {
      hasRole: function() {
        return this.$store.getters["common/promise/getRole"](this.$route.path);
      },
    },
    created() {
      this.getListData();
    },
    methods: {
      async getUserSimpleListFun(v = "") {
        this.canSearch = false;
        const res = await getUserSimpleList({
          keyword: v,
          size: 1000
        });
        if (res.code === 200) {
          this.peopleList = res.data;
        }
        this.canSearch = true;
      },
      async searchProjectList(keyword) {
        const res = await getProjectSimpleList({
          keyword: keyword,
          size: 100,
        });
        if (res.code === 200) {
          this.projectList = res.data;
        }
      },
      async getListData() {
        this.tableLoading = true;
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        for (let key in this.form) {
          if (this.form[key]) params[key] = this.form[key];
        }
        if (this.createTime && this.createTime.length) {
          this.form.operatorTimeStart = this.createTime[0];
          this.form.operatorTimeEnd = this.createTime[1];
        } else {
          this.form.operatorTimeStart = ""
          this.form.operatorTimeEnd = ""
        }
        const res = await getPageList(params);
        if (res.code === 200) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
        this.tableLoading = false;
      },
      handleSearch() {
        this.pageIndex = 1;
        this.getListData();
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = [];
          } else {
            this.form[key] = "";
          }
          this.createTime = null
        }
        this.pageIndex = 1;
        this.getListData();
      },
      handleSearchListData() {
        this.pageIndex = 1;
        this.getListData();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleDeleteCause(row) {
        const idList = [row.id];
        this.deleteCause(idList);
      },
      handleAcceptCause(row) {
        this.$confirm("确定接收?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            const res = await accept({
              id: row.id
            });
            if (res.code === 200) {
              this.$message.success("接收成功");
              this.getListData();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      handleCheck(row) {
        this.causeDetail = row;
        this.checkDepartment = true;
      },
      handleEdit(row) {
        this.causeDetail = row;
        this.editCauseVisible = true;
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning("请选择要删除的行");
          return;
        }
        const idList = this.multipleSelection.map((item) => item.id);
        this.deleteData(idList);
      },
      deleteCause(idList) {
        this.$confirm("确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            const res = await deleteData({
              idList,
            });
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.getListData();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      handleAdd() {
        this.addCauseVisible = true;
      },
      exportCause() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        for (let key in this.form) {
          if (this.form[key]) params[key] = this.form[key];
        }
        exportCause(params);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getListData();
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getListData();
      },
      handleAddCauseConfirm() {
        this.addCauseVisible = false;
        this.pageIndex = 1;
        this.getListData();
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false;
        this.getListData();
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/salesManagement/transferOrder/TransferOrderManagement.vue